'use strict';

wbApp.controller('BankUnimportantRecoveryDetailCtrl', ['$scope', 'bankSvc',
function ($scope, bankSvc) {

    $scope.filterOptions = {
        filterText: ""
    };

    $scope.transactions = bankSvc.getUnimportantByAccountingBookID($scope.accountingBookID,
        $scope.fromDate, $scope.toDate);

    $scope.gridOptions = {
        sortInfo: { fields: ['date'], directions: ['dsc'] },
        columnDefs: [{ field: 'date', displayName: "TXT_LBL_DATE", cellFilter: 'date:shortDate', width: '75px' },
                     { field: 'invoiceNo', displayName: "TXT_LBL_VARIABLE_SYMBOL", width: '120px', align: 'right' },
                     { field: 'externalAccountNo', displayName: "TXT_LBL_EXTERNAL_ACCOUNT", width: '190px', align: 'right', smHide: true, mdHide: true },
                     { field: 'text', displayName: "TXT_LBL_TEXT", sort: 'locale' },
                     { field: 'value', displayName: "TXT_LBL_VALUE", cellFilter: 'wbCurrencyFlt', width: '100px', align: 'right' }
        ],
        noCommandColumn: true,
        hideFooter: false,
        multiSelect: true
    };

    var isSaving = false;

    $scope.isReadyToSave = function () {
        return _.some($scope.transactions, 'isSelected') && !isSaving;
    }

    $scope.onDetailSave = function () {

        isSaving = true;

        let selected = _.map(_.filter($scope.transactions, { 'isSelected' : true }), 'transactionID');
        bankSvc.restoreUnimportant($scope.accountingBookID, selected)
        .then(function () {
            isSaving = false;
            $scope.$hide();
            $scope.onSave();
        }, function () { isSaving = false; });
    }

}]);
